import type { StorytellerOptions } from './types';

import { getOptionsProvider } from '@shared/OptionsProvider';

export const { OptionsProvider: StorytellerOptionsProvider, useOptions: useStorytellerOptions } =
  getOptionsProvider<StorytellerOptions>();
